import { connect } from 'react-redux';
import View from './RetirementExpensesView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  RETIREMENT_EXPENSES_WHAT_IF_KEY,
  RETIREMENT_EXPENSES_WHAT_IF_PATH,
} from './RetirementExpensesConstants';
import {
  hasRetirementExpensesAmountSelector,
  retirementExpensesOptionsSelector,
  retirementExpensesAmountSelector,
  retirementExpensesSelector,
} from './RetirementExpensesSelector';
import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  planImpact,
  initialPlanImpact,
} from '../../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  isOPLMonteCarloSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  hasRetirementExpensesAmount: hasRetirementExpensesAmountSelector(state, ownProps),
  retirementExpensesOptions: retirementExpensesOptionsSelector(state, ownProps),
  retirementExpensesAmount: retirementExpensesAmountSelector(state, ownProps),
  retirementExpenses: retirementExpensesSelector(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  isOPLMonteCarlo: isOPLMonteCarloSelector(state),
});

const mapDispatchToProps = dispatch => ({
  storeData: goalId => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, RETIREMENT_EXPENSES_WHAT_IF_KEY, data));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RETIREMENT_EXPENSES_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        RETIREMENT_EXPENSES_WHAT_IF_KEY,
      ),
    );
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RETIREMENT_EXPENSES_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        RETIREMENT_EXPENSES_WHAT_IF_KEY,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId) => {
    dispatch(
      fetchWhatIfOptions(
        clientId,
        fpId,
        goalId,
        RETIREMENT_EXPENSES_WHAT_IF_PATH,
        RETIREMENT_EXPENSES_WHAT_IF_KEY,
      ),
    );
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        whatIf,
        RETIREMENT_EXPENSES_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        RETIREMENT_EXPENSES_WHAT_IF_KEY,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
